import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'stripHtml',
  standalone: true
})
export class StripHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, wordLimit: number = 50): string {
    if (!value) return '';
    
    // Create a temporary div to decode HTML entities
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = value;
    
    // Get text content which will decode HTML entities
    let text = tempDiv.textContent || tempDiv.innerText || '';
    
    // Replace multiple spaces, newlines, and tabs with a single space
    text = text.replace(/\s+/g, ' ').trim();
    
    // Split into words and limit
    const words = text.split(' ').filter(word => word.length > 0);
    if (words.length <= wordLimit) return text;
    
    return words.slice(0, wordLimit).join(' ') + '...';
  }
}
